module.exports = __webpack_public_path__ + "assets/icon-toggle-green.1da8c360.svg";